import { PrimitiveField } from '../fields/createPrimitiveField';
import { FieldValidator } from '../fields/validation';
import { ValidationError, ValidationComparisonValue } from '../types';
import { handleComparisonValidation } from './helpers/handleComparisonValidation';

type MatchValidatorError<Code extends string> = ValidationError<Code, { regexp: string }>;

/**
 * Создает валидатор, проверяющий на совпадение переданному регулярному выражению
 * @param regexp регулярное выражение, по которому проверяется строка
 * @param code код ошибки
 * @returns валидатор
 */
export function matchValidator<
    Code extends string,
    FieldValue extends string,
    FieldContextInput,
    FieldContext,
    FieldActions,
    FieldSelectors,
>(
    regexp: ValidationComparisonValue<RegExp, FieldContext>,
    code: Code
): FieldValidator<
    PrimitiveField<FieldValue, MatchValidatorError<Code>, FieldContextInput, FieldContext, FieldActions, FieldSelectors>
> {
    return (value, fieldApi) => {
        const validationCallback = (handledRegexp: RegExp) => {
            if (!handledRegexp.test(value)) {
                fieldApi.addValidationError({
                    code,
                    params: { regexp: String(handledRegexp) },
                });
            }
        };

        return handleComparisonValidation({
            comparisonValue: regexp,
            context: fieldApi.getContext(),
            validationCallback,
        });
    };
}
